import { PayloadMessageType } from '@iotv/iotv-v3-types'
import { ModelCommon } from '../ModelCommon'

const typeName = 'DeviceMessage'

export interface IDeviceMessage {
  payload?: PayloadMessageType
}

class DeviceMessage extends ModelCommon implements IDeviceMessage {
  constructor(ob: any) {
    super(typeName, ob)
  }
  payload?: PayloadMessageType | undefined
}

export { DeviceMessage }
